import React from 'react';
import Markup from "interweave";

const NewsItem = ({item}) => (

  <div className="meeting">
    <h3 className="heading__medium">{item.title}</h3>
    <a
      className="button__submit" href={ item.agenda}
      download={item.agenda}>Download Agenda</a>
    <a className="button__submit" href={item.minutes} download={item.minutes}>Download Minutes</a>
  </div>
);

export default NewsItem;


